<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
 <!-- <img class="nestbanner" src = "assets/images/home.jpg"> -->




  <!-- <div class="container-login"  >
      <div class="wrap-login">
        <div class="row">


              <div class="form-group"  >

                  <form [formGroup]="registrationform"  (ngSubmit)=" doSignup()">
                      <div class="wrap-inputlogin form-group">

                      <input type="text" name="name" placeholder="Enter your Name" id="name" [(ngModel)]="registrationform.name" class="inputlogin form-control" formControlName="name" >
                      <span class="symbol-inputlogin">
                        <i class="fa fa-user" aria-hidden="true"></i>
                      </span>
                      </div>
                      <div  *ngIf="( registrationform.get('name').hasError('required') ) && registrationform.get('name').touched">

                              <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('name').hasError('required') && registrationform.get('name').touched">
                              Name is required
                            </div>
                      </div>

                      <div class="wrap-inputlogin form-group">

                      <input type="email" placeholder="Enter email Id" name="email" id="email" [(ngModel)]="registrationform.email" class="inputlogin form-control" formControlName="email" required>
                      <span class="symbol-inputlogin">
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                      </span>
                      </div>

                      <div *ngIf="( registrationform.get('email').hasError('required') || registrationform.get('email').hasError('pattern') ) && registrationform.get('email').touched">

                                  <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('email').hasError('required') && registrationform.get('email').touched">
                                            Email is required
                                  </div>
                                  <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('email').hasError('pattern') && registrationform.get('email').touched">
                                              Enter Correct Email Id
                                  </div>
                      </div>



                      <div class="wrap-inputlogin form-group">

                      <input type="mobile" placeholder="Enter Mobile No" name="mobile" id="mobile" [(ngModel)]="registrationform.mobile" class="inputlogin form-control" formControlName="mobile" required>
                      <span class="symbol-inputlogin">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                      </span>
                      </div>

                      <div  *ngIf="( registrationform.get('mobile').hasError('required')  || registrationform.get('mobile').hasError('minLength') ) && registrationform.get('mobile').touched">

                        <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('mobile').hasError('required') && registrationform.get('mobile').touched">
                          Mobile Number is required
                        </div>
                        <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('mobile').hasError('minLength') && registrationform.get('mobile').touched">
                          This is not a valid Mobile Number
                        </div>

                      </div>


                      <div class="wrap-inputlogin form-group">
                      <input type="noofpets" placeholder="No of Pets" name="noofpets" id="noofpets"  [(ngModel)]="registrationform.noofpets" class="inputlogin form-control" formControlName="noofpets" required>
                      <span class="symbol-inputlogin">
                        <i class="fas fa-paw" aria-hidden="true"></i>
                      </span>

                      </div>

                      <div *ngIf="( registrationform.get('noofpets').hasError('required') ) && registrationform.get('noofpets').touched">

                                            <div class="error" style="color:red;font-size:10px" *ngIf="registrationform.get('noofpets').hasError('required') && registrationform.get('noofpets').touched">
                                            No of Pets is required
                                            </div>

                                          </div>




                      <div class="wrap-inputlogin form-group smlfnt" >


                                  <mat-radio-group [(ngModel)]="typeofpets" formControlName="typeofpets">Pet Type:
                                  <mat-radio-button value="dog">Dog</mat-radio-button>
                                  <mat-radio-button value="cat">Cat</mat-radio-button>
                                  <mat-radio-button value="dogandcat">Dog & Cat</mat-radio-button>
                                  <mat-radio-button value="others">Others</mat-radio-button>
                                </mat-radio-group>

                          </div>








                                  <div class="row regnsml">
                                      <div class="col-12">
                                              <button  class="btn login" type="submit" [disabled]="!registrationform.valid">Notify Me</button>
                                      </div>


                                        </div>
          </form>
                  </div>

    </div>
  </div>
  </div> -->

 <div class="nestbg">
    </div>









  <!--  <div class="bg1 home">
      <div data-poster-url="https://uploads-ssl.webflow.com/5aa21e0e8598c900010e155c/5aa22f208598c900010e1c02_53fa5639-72f4-4208-97cd-0daabd9815e7-poster-00001.jpg" data-video-urls="videos/53fa5639-72f4-4208-97cd-0daabd9815e7-transcode.webm,videos/53fa5639-72f4-4208-97cd-0daabd9815e7-transcode.mp4" data-autoplay="true" data-loop="true" data-wf-ignore="true" class="background-video w-background-video w-background-video-atom"><video autoplay="" loop="" style="background-image:url(&quot;https://uploads-ssl.webflow.com/5aa21e0e8598c900010e155c/5aa22f208598c900010e1c02_53fa5639-72f4-4208-97cd-0daabd9815e7-poster-00001.jpg&quot;)" data-wf-ignore="true"><source src="videos/53fa5639-72f4-4208-97cd-0daabd9815e7-transcode.webm" data-wf-ignore="true"><source src="videos/53fa5639-72f4-4208-97cd-0daabd9815e7-transcode.mp4" data-wf-ignore="true"></video>
        <div class="button-link"><a href="store.html" class="button w-button">Store</a></div>
        <div class="button-link _1"><a href="pulse.html" class="button w-button">Pulse</a></div>
        <div class="button-link _1"><a href="index.html" class="button w-button">Home</a></div>
        <h1 class="heading-19">We love your pets <br>as much as you do...</h1>
      </div>
    </div> -->
    <div class="footercontact">
    </div>

  <div >
    <div class="row" style="margin-top:0px;margin-bottom: 100px;">

      <div class="col-lg-6 col-sm-12 nestfeatures">


        <button routerLink="/nest/booking" class="btn btn-outline-success btn-block" style="bottom: 40px;
        position: fixed;
        z-index: 2000;">
                              Book Boarding Service</button>


    </div>
 

      <div class="col-lg-6 col-sm-12 carnival">

    <button routerLink="/nest/carnival" class="btn btn-outline-success btn-block" style="bottom: 0px; left:0px;
    position: fixed;
    z-index: 2000;">
                          Tariff Card </button>
  </div>



  </div>
  </div>
